import { getTooltip, setLoggedIn, updateBrand, updateTooltip } from "api";
import { phone } from "assets";
import Button from "components/global/Button";
import FormGroup from "components/global/FormGroup";
import FormWrapper from "components/global/FormWrapper";
import { Formik } from "formik";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { showAlert } from "utils/utils";
import * as Yup from "yup";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .headerContainer {
    max-width: 400px;
    text-align: center;
    gap: 6px;

    p {
      font-size: 14px;
      line-height: 20px;
    }
  }

  label {
    color: var(--body-text);
  }

  .footer {
    position: sticky;
    bottom: 0;
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 50px;
    .headerContainer {
      max-width: 327px;
    }
  }
`;

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string(),
  brand_description: Yup.string().required("Brand description is required"),
});

const CreateBrandWithSocials = ({
  user,
  brand,
  onboarding_state,
  brandInfo,
  user_token,
  refresh_token,
}) => {
  const history = useHistory();
  const { search } = useLocation();
  const postpaddyMobile = new URLSearchParams(search).get("postpaddy-mobile");
  const mobileUrl = localStorage.getItem("mobileUrl");
  const authMobileProvider = localStorage.getItem("authMobileProvider");

  const submitForm = async (values, setSubmitting) => {
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      formData.append(key, values[key]);
    });

    setSubmitting(true);
    try {
      const res = await updateBrand(formData, brand?.id);

      if (res?.data?.status === true) {
        const res = await updateTooltip({
          ...onboarding_state,
          confirm_brand_details: true,
        });
        if (res?.data?.status === true) {
          await getTooltip();
        }
        setSubmitting(false);

        if (postpaddyMobile || mobileUrl || authMobileProvider) {
          window.location.href = `postpaddy.app://(brands)/screen-two?token=${user_token}&refresh_token=${refresh_token}&success=true`;
          localStorage.removeItem("mobileUrl");
          setLoggedIn(false);
          return;
        }

        history.replace("/onboarding/connect-socials");
      } else if (res?.data?.status === false) {
        setSubmitting(false);
        showAlert({
          type: "danger",
          msg: res.data.message,
        });
      }
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
      showAlert({
        type: "danger",
        msg: e.response?.data?.message ?? "An error occurred",
      });
    }
  };

  return (
    <Wrapper>
      <div className="headerContainer">
        <h4>Welcome to PostPaddy</h4>
        <p className="l3 colorBodyText">Confirm your details</p>
      </div>
      <Formik
        initialValues={{
          name: user?.full_name ?? "",
          email: user?.email ?? "",
          phone: "",
          brand_description: brandInfo?.description ?? "",
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          if (values.phone === "") {
            delete values.phone;
          }
          await submitForm(values, setSubmitting);
        }}
      >
        {({ handleSubmit, isSubmitting, isValid, dirty }) => (
          <FormWrapper onSubmit={handleSubmit}>
            <FormGroup
              fieldStyle="shortText"
              type="text"
              label="Full name"
              name="name"
              className="spanFull"
              required={false}
            />
            <FormGroup
              fieldStyle="shortText"
              type="email"
              label="Email address"
              name="email"
              className="spanFull"
              placeholder="e.g. janedoe@example.com"
              required={false}
            />
            <FormGroup
              fieldStyle="shortText"
              type="tel"
              label="Phone number (optional)"
              name="phone"
              required={false}
              phoneInput
              className="spanFull"
              placeholder="090 3040 8044"
            />
            <FormGroup
              fieldStyle="longText"
              type="text"
              label="Brand description"
              name="brand_description"
              className="spanFull"
              required={false}
            />
            <div className="footer spanFull">
              <Button
                type="submit"
                text="Next"
                className="spanFull"
                disabled={!isValid || isSubmitting}
                loading={isSubmitting}
                fullWidth
              />
            </div>
          </FormWrapper>
        )}
      </Formik>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  brand: state.brand,
  onboarding_state: state.guided_tours,
  brandInfo: state.ai_brand_info,
  user_token: state.user_token,
  refresh_token: state.refresh_token,
});

export default connect(mapStateToProps)(CreateBrandWithSocials);
